/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {completeCopyModal} from '../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {createResourceCopy} from '../../components/util/create-resource-copy';
import {nextCopyTitle} from '../../components/util/next-copy-title';
import {Uuid} from '../../components/util/uuid';
import {normalizeSiteIabCategories} from './site-commons';
import {SiteResource} from '../../components/api/resources/resource/site.resource';

export interface SiteCopyResult {
  model: any;
  destination: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-site-copy-modal',
  template: `
    <form class="form-horizontal" (ngSubmit)="copy()">
      <div class="modal-header dialogAddStuff">
        <button type="button" class="close" (click)="dismiss()">&times;</button>
        <h4 class="modal-title">
          <span>{{ 'label.copy.site' | ogTranslate }}</span>
          <small>{{ originalName }}</small>
        </h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.name' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="site.name" [(ngModel)]="name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'label.description' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="text" class="form-control" name="site.description" [(ngModel)]="description">
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">{{ 'site.siteUrl' | ogTranslate }}</label>
          <div class="col-md-9">
            <input type="url" name="site.siteUrl" class="form-control" [(ngModel)]="siteUrl" adnHttpsPrefixer>
          </div>
        </div>
        <div class="checkbox text-right">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="destination" name="site.destination">
            <span class="small">Go to new site after copy</span>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <a class="btn btn-link btn-xs" (click)="dismiss()">{{ 'button.cancel' | ogTranslate }}</a>
        <button type="submit" class="btn btn-default">{{ 'label.copy' | ogTranslate }}</button>
      </div>
    </form>
  `
})
export class SiteCopyModalComponent implements OnInit {
  model: any;

  readonly onCopied = new Subject<SiteCopyResult>();

  originalName = '';
  name = '';
  description = '';
  siteUrl = '';
  destination = true;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(SiteResource) private readonly Site: any
  ) {
  }

  ngOnInit(): void {
    this.originalName = this.model?.name || '';
    this.name = nextCopyTitle(this.model?.name || '');
    this.description = this.model?.description || '';
    this.siteUrl = this.model?.siteUrl || '';
  }

  copy(): void {
    const copy = createResourceCopy(this.Site, this.model, {
      id: Uuid.generate(),
      name: this.name,
      description: this.description || null,
      siteUrl: this.siteUrl || null
    });
    normalizeSiteIabCategories(copy);
    copy.$save().then((saved: any) => {
      completeCopyModal(this.bsModalRef, this.onCopied, {model: saved, destination: this.destination});
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
